<script setup>
import { onMounted } from "vue";
import AppHeader from "@/components/layout/AppHeader.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { changelogEntries } from "@/shared/copy/changelog";
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();

onMounted(() => {
  auth.loadAuth();
});
</script>

<template>
  <main class="app-shell">
    <AppHeader login-redirect="/tokenomics/changelog" />

    <section class="page-hero">
      <div class="container">
        <h1>更新日志</h1>
        <p>token economics web、mac app 和上传链路最近几次用户可见变化。</p>
      </div>
    </section>

    <section class="changelog-body">
      <div class="timeline" aria-label="Token Economics 更新日志">
        <div class="timeline-rail" aria-hidden="true"></div>
        <div class="timeline-list">
          <article v-for="entry in changelogEntries" :key="`${entry.date}-${entry.title}`" class="timeline-entry">
            <div class="timeline-dot" aria-hidden="true"></div>
            <div class="entry-card">
              <div class="entry-meta">
                <time class="pill-solid" :datetime="entry.date">{{ entry.date }}</time>
                <span class="pill-outline">{{ entry.tag }}</span>
                <span class="entry-source">{{ entry.source }}</span>
              </div>
              <h2>{{ entry.title }}</h2>
              <ul>
                <li v-for="change in entry.changes" :key="change">{{ change }}</li>
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>

    <AppFooter />
  </main>
</template>
